import React from 'react';
import ServiceCard from './ServiceCard';
import ServiceListItem from './ServiceListItem';

const ServiceGrid = ({ services, viewMode, onRequestQuote }) => {
  if (services?.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">🔍</span>
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">No services found</h3>
        <p className="text-muted-foreground">
          Try adjusting your filters or search terms to find what you're looking for.
        </p>
      </div>
    );
  }

  if (viewMode === 'list') {
    return (
      <div className="space-y-4">
        {services?.map((service) => (
          <ServiceListItem
            key={service?.id}
            service={service}
            onRequestQuote={onRequestQuote}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {services?.map((service) => (
        <ServiceCard
          key={service?.id}
          service={service}
          onRequestQuote={onRequestQuote}
        />
      ))}
    </div>
  );
};

export default ServiceGrid;